module.exports = "../../app/cells/components/related_contests_cell.rb";